(function (window, $) {
  var Cls = {};
  var firstFlag = false;
  var $title = null;
  var $cat0_obj1 = null;
  var $cat0_obj2 = null;
  var $cat0_obj3 = null;
  var $cat0_obj4 = null;
  var $cat1_obj1 = null;
  var $cat1_obj2 = null;
  var $cat1_obj3 = null;
  var $cat1_obj4 = null;

  Cls.init = function () {
    $title = $("#seg3 .title1");
    $cat0_obj1 = $("#seg3 .cat0 .obj1");
    $cat0_obj2 = $("#seg3 .cat0 .obj2");
    $cat0_obj3 = $("#seg3 .cat0 .obj3");
    $cat0_obj4 = $("#seg3 .cat0 .obj4");
    $cat1_obj1 = $("#seg3 .cat1 .obj1");
    $cat1_obj2 = $("#seg3 .cat1 .obj2");
    $cat1_obj3 = $("#seg3 .cat1 .obj3");
    $cat1_obj4 = $("#seg3 .cat1 .obj4");
  };
  Cls.fixedAreaAnime = function () {
    if (firstFlag !== true)
      Anime.vertical($title, "-=100px", 700, 1200, "easeOutQuint");
    firstFlag = true;
  };
  Cls.cat0 = function () {
    $cat0_obj1.stop().css({ opacity: "0" });
    $cat0_obj1
      .stop()
      .css({ opacity: "0" })
      .delay(1000)
      .animate({ opacity: 1 }, 1200);
    $cat0_obj2
      .stop()
      .css({ opacity: "0" })
      .delay(1000)
      .animate({ opacity: 1 }, 1200);
    $cat0_obj3
      .stop()
      .css({ opacity: "0", height: "0px" })
      .delay(1800)
      .animate({ opacity: 1, height: "93px" }, 1200);
    $cat0_obj4
      .stop()
      .css({ opacity: "0" })
      .delay(2600)
      .animate({ opacity: 1 }, 2200, "");
    Cls.fixedAreaAnime();
  };
  Cls.cat1 = function () {
    $cat1_obj1.stop().css({ opacity: "0" });
    $cat1_obj1
      .stop()
      .css({ opacity: "0" })
      .delay(1000)
      .animate({ opacity: 1 }, 1200);
    $cat1_obj2
      .stop()
      .css({ opacity: "0" })
      .delay(1000)
      .animate({ opacity: 1 }, 1200);
    $cat1_obj3
      .stop()
      .css({ opacity: "0", height: "0px" })
      .delay(1800)
      .animate({ opacity: 1, height: "93px" }, 1200);
    $cat1_obj4
      .stop()
      .css({ opacity: "0" })
      .delay(2600)
      .animate({ opacity: 1 }, 2200, "");
  };

  window.Seg3 = Cls;
})(window, $brand);
